import { JsonObject, JsonProperty } from 'json-ts-mapper';
import { Article } from './article';
import { LieuDepart } from './lieu-depart';

@JsonObject
export class ArticleLieuDepart {
  constructor (
    id?: number,
    article?: Article,
    lieuDepart?: LieuDepart,
    commentaire?: string,
    domaine?: string
  ) {
    this.id = id as any;
    this.article = article as any;
    this.lieuDepart = lieuDepart as any;
    this.commentaire = commentaire as any;
    this.domaine = domaine as any;
  }

  @JsonProperty(Number)
  id: number;

  @JsonProperty(Article)
  article: Article;

  @JsonProperty(LieuDepart)
  lieuDepart: LieuDepart;

  @JsonProperty(String)
  commentaire: string;

  @JsonProperty(String)
  domaine: string;
}
